import {
  USER_LOGIN_SUCCESS,
  USER_LOGGED_IN,
  USER_LOGOUT,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_CALENDAR_TOKEN,
} from 'config/constants';

export default (state = null, action) => {
  const { type, user } = action;
  switch (type) {
    case USER_LOGIN_SUCCESS:
    case USER_LOGGED_IN:
      return user;
    case USER_LOGOUT:
      return null;
    case USER_UPDATE_SUCCESS:
      return user;
    case USER_UPDATE_CALENDAR_TOKEN:
      const { code } = action;
      const newUser = { ...state, calendar_token: code };
      localStorage.setItem('user', JSON.stringify(newUser));
      return newUser;
    default:
      return state;
  }
};
